export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/sk.b2822ca0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};